import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { salaryReport as actions, notificationActions } from '../actions';
import { reportService } from '../services';

/* Add Report Sagas */
function* handleSalaryReportRequest() {
  const action = yield take(actions.salaryReportRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(reportService.salaryReport, dataParams);
    if (res.isError) {
      yield put(actions.salaryReportError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.salaryReportSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.salaryReportError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* -----------Watchers------------- */
function* handleSalaryReportWatcher() {
  yield takeEvery(
    actions.salaryReportRequest,
    handleSalaryReportRequest,
  );
}



function* rootReportSaga() {
  yield all([
    handleSalaryReportRequest(),
    handleSalaryReportWatcher(),
  ]);
}

export default rootReportSaga;
